import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28 5.765v20.47A1.764 1.764 0 0 1 26.235 28H5.765A1.765 1.765 0 0 1 4 26.235V5.765A1.765 1.765 0 0 1 5.765 4h20.47A1.765 1.765 0 0 1 28 5.765Zm-16.941 7.412h-3.53V24.47h3.53V13.177Zm.318-3.883a2.033 2.033 0 0 0-2.02-2.047h-.063a2.047 2.047 0 1 0 0 4.094 2.035 2.035 0 0 0 2.082-1.983v-.064ZM24.47 17.61c0-3.395-2.16-4.715-4.306-4.715a4.024 4.024 0 0 0-3.572 1.821h-.099v-1.538h-3.317V24.47h3.529v-6.008a2.344 2.344 0 0 1 2.117-2.527h.135c1.122 0 1.955.706 1.955 2.485v6.05h3.53l.028-6.862Z"
      fill="#325a32"
    />
  </svg>
);

export default SvgComponent;
